import { api } from './api';
export const actorsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取演员列表
        getActors: builder.query({
            query: (filters) => ({
                url: '/actors',
                params: filters,
            }),
            providesTags: ['Actors'],
        }),
        // 获取单个演员
        getActor: builder.query({
            query: (id) => `/actors/${id}`,
            providesTags: (result, error, id) => [{ type: 'Actors', id }],
        }),
        // 创建演员
        createActor: builder.mutation({
            query: (actor) => ({
                url: '/actors',
                method: 'POST',
                body: actor,
            }),
            invalidatesTags: ['Actors'],
        }),
        // 更新演员
        updateActor: builder.mutation({
            query: ({ id, data }) => ({
                url: `/actors/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Actors', id }, 'Actors'],
        }),
        // 删除演员
        deleteActor: builder.mutation({
            query: (id) => ({
                url: `/actors/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Actors'],
        }),
        // 上传演员照片
        uploadActorPhoto: builder.mutation({
            query: ({ actorId, photo }) => {
                const formData = new FormData();
                formData.append('photo', photo);
                return {
                    url: `/actors/${actorId}/photo`,
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: (result, error, { actorId }) => [{ type: 'Actors', id: actorId }],
        }),
    }),
});
export const { useGetActorsQuery, useGetActorQuery, useCreateActorMutation, useUpdateActorMutation, useDeleteActorMutation, useUploadActorPhotoMutation, } = actorsApi;
